module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@2x-d910fdcb79af2eaef99f0d2eea0df8fa.png";